if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

const personalization = document.querySelector("[js-personalization-item]");

if(personalization) {
  const formId = personalization.getAttribute("data-form-id");
  const dropdownItem = personalization.querySelectorAll("[js-dropdown-item]");
  const tabItems = personalization.querySelectorAll("[js-tab-item]");
  const tabPanels = personalization.querySelectorAll("[js-tab-panel]");
  const previewImages = personalization.querySelectorAll("[js-preview-img]");
  const fontStyleSelect = personalization.querySelectorAll("[js-font-style-select]");
  const colorSelect = personalization.querySelectorAll("[js-color-select]");
  const colorImageEls = personalization.querySelectorAll("[js-color-img]");
  const colorImageWrap = personalization.querySelector("[js-color-preview-wrapper]");
  const productVariantIdField = document.querySelector("[js-product-variant-id]");

  dropdownItem.forEach( el => {
    el.addEventListener("click", function() {
      const details = this.closest("details");
      const inputFields = details.querySelectorAll("input");
      const summaryLabel = details.querySelector("[js-summary-label]");
      const refFields = details.querySelectorAll("[js-embellishment-ref-id]");

      summaryLabel.innerHTML = this.innerHTML;
      details.removeAttribute("open");

      if(this.getAttribute("is") === "embellishment") {
        inputFields.forEach( j => {
          j.setAttribute("form", formId);
          j.removeAttribute('disabled');
        });
        refFields.forEach(t => t.value = +new Date());
      }else {
        inputFields.forEach(j => {
          j.removeAttribute("form");
          j.setAttribute('disabled','disabled');
        });
        refFields.forEach(t => t.value = "");
      }

      updatePrice();
    })
  })

  tabItems.forEach( el => {
    el.addEventListener("click", function() {
      const id = this.getAttribute("id");
      tabItems.forEach(item => item.classList.remove("is-active"));
      tabPanels.forEach(item => item.classList.add("hidden"));

      this.classList.add("is-active");
      personalization.querySelector(`[js-tab-panel][data-index="${id}"]`).classList.remove("hidden");
    })
  })

  fontStyleSelect?.forEach(el => el.addEventListener("change", function() {
    const tabPanel = this.closest("[js-tab-panel]");
    tabPanel.querySelectorAll(`[js-preview-img]`).forEach(i => i.classList.add("hidden"));
    tabPanel.querySelector(`[js-preview-img][data-index="${this.selectedIndex}"]`)?.classList.remove("hidden");
  const imageLink =  tabPanel.querySelector(`[js-preview-img][data-index="${this.selectedIndex}"]`);
    console.log(imageLink);
  }));

colorSelect?.forEach(el =>
  el.addEventListener("change", function () {
    const tabPanel = this.closest("[js-tab-panel]");

    // Hide all images in current tab
    tabPanel.querySelectorAll(`[js-color-img]`).forEach(i => i.classList.add("hidden"));

    // Show selected image (this is working fine)
    const selectedImage = tabPanel.querySelector(`[js-color-img][data-index='${this.selectedIndex}']`);
    selectedImage?.classList.remove("hidden");

    // ✅ FIXED: Update the hidden input scoped inside this tab only
    const previewInput = tabPanel.querySelector('[js-preview-image-property]');
    if (previewInput && selectedImage) {
      previewInput.value = selectedImage.src;
    }
  })
);


  if(productVariantIdField.getAttribute("is") === "personalized") {
    setTimeout(function() {
      productVariantIdField.setAttribute("disabled", "true");
    }, 3000)
  }
}
